module.exports = __webpack_public_path__ + "static/media/kea-apply-wall-paper-4.b8232262.png";